import { EMPTY_OBJECT } from '../../../../constants/common'
import { getUserAvatar } from '../../../../utils/user'
import { ENTITY_PROFILE_TAB_UPDATES_OWNER_TYPE } from '../EntityProfileTabUpdates.constants'

import ProviderIcon from '../../../../icons/provider.svg'
import UserIcon from '../../../../icons/user.svg'

export function getEntityProfileTabUpdateAvatarProps({
  owner = EMPTY_OBJECT,
  type,
}) {
  switch (type) {
    case ENTITY_PROFILE_TAB_UPDATES_OWNER_TYPE.system:
      return { Icon: UserIcon }
    case ENTITY_PROFILE_TAB_UPDATES_OWNER_TYPE.deleted:
      return { Icon: UserIcon }
    case ENTITY_PROFILE_TAB_UPDATES_OWNER_TYPE.worker:
      return { Icon: ProviderIcon }
    default:
      return getUserAvatar(owner)
  }
}
